/** Artifacts — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ARTIFACT_TYPES,
  ARTIFACT_STATUS,
  PRIORITY,
  createArtifactSchema,
  type CreateArtifactInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "../projects/_shared";
import {
  FormGrid,
  SelectField,
  TextAreaField,
  TextField,
} from "../projects/_form";

export function ArtifactCreate() {
  const form = useForm<CreateArtifactInput, any, CreateArtifactInput>({
    resolver: zodResolver(createArtifactSchema),
    defaultValues: {
      title: "",
      artifact_type: "task",
      status: "new",
      description: "",
      project_id: "",
      owner_user_id: "",
      priority: "medium",
      due_date: "",
      source_system: "",
      external_url: "",
    },
    refineCoreProps: { resource: "artifacts", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="New Artifact" description="Create an artifact." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Artifact details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <TextField
                control={control}
                name="title"
                label="Title"
                placeholder="Foundation inspection"
              />
              <FormGrid>
                <SelectField
                  control={control}
                  name="artifact_type"
                  label="Type"
                  options={ARTIFACT_TYPES}
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ARTIFACT_STATUS}
                />
                <SelectField
                  control={control}
                  name="priority"
                  label="Priority"
                  options={PRIORITY}
                />
                <TextField
                  control={control}
                  name="due_date"
                  label="Due date"
                  type="date"
                />
                <TextField
                  control={control}
                  name="project_id"
                  label="Project ID"
                  placeholder="prj_…"
                />
                <TextField
                  control={control}
                  name="owner_user_id"
                  label="Owner User ID"
                  placeholder="user_…"
                />
                <TextField
                  control={control}
                  name="source_system"
                  label="Source system"
                  placeholder="portal"
                />
                <TextField
                  control={control}
                  name="external_url"
                  label="External URL"
                  placeholder="https://…"
                />
              </FormGrid>
              <TextAreaField
                control={control}
                name="description"
                label="Description"
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create Artifact"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default ArtifactCreate;
